import React from 'react'
import { CrudPageContent } from '@morningtrain/react-crud'
import * as Columns from 'support/columns'
import * as Displays from 'support/displays'
import * as Filters from 'support/filters'
import IndexLayout from 'layouts/crud/IndexLayout'
import AddToCart from 'support/actions/AddToCart'
import { Link } from '@morningtrain/react-navigation'
import { ChangeQuantity } from 'support/displays'
import CartWrapper from 'services/cart/CartWrapper'
import DomainInfoColumns from 'widgets/domains/DomainInfoColumns'
import DualRowColumn from 'ui/columns/DualRowColumn'
import WhenModelValuesNotEqual
  from 'support/conditionals/WhenModelValuesNotEqual'

export default class Index extends CrudPageContent {
  get resourceName () {
    return 'domains'
  }

  get layout () {
    return IndexLayout
  }

  get filters () {
    return (
      <>
        <Filters.SearchFilter />
      </>
    )
  }

  get columns () {
    return (
      <>
        <DomainInfoColumns />
        <Columns.Column display={ChangeQuantity} label='Antal Links' />
      </>
    )
  }

  get actions () {
    return (
      <>
        <AddToCart />
      </>
    )
  }

  renderAfterCrud () {
    return null
  }

  get crudProps () {
    return {
      ...super.crudProps,
      titleSubContent: (
        <p className='mt-2 text-sm text-gray-600'>
          <Link href='https://business.jfm.dk/kontakt-os/' newTab={true} className='font-medium text-primary-600 hover:underline'>
            Kontakt os
          </Link>
          {' '} og hør nærmere om vores priser
        </p>
      )
    }
  }

  render () {
    return (
      <CartWrapper>
        {super.render()}
      </CartWrapper>
    )
  }
}
